import { Injectable } from '@angular/core';
import { loaderTypes } from '@app/shared/component/loader/loader';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';

@Injectable({
  providedIn: 'root',
})
export class OfficeService {
  constructor(private readonly httpService: AmplifyHttpClient) {}

  private clientSelect = new Subject<any>();
  private folderCreated = new Subject<any>();
  private toClientGroup = new Subject<any>();

  createWorkspace(request) {
    const url = `api/office/workspace`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  updateWorkspace(request) {
    const url = `api/office/workspace`;
    return this.httpService.patch(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  deleteWorkspace(request) {
    const url = `api/office/workspace/${request}`;
    return this.httpService.delete(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  getWorkspaceFolders(workspaceId, folderId?: any) {
    let url;

    folderId ? (url = `api/office/workspace-folder/${workspaceId}/${folderId}`) : (url = `api/office/workspace-folder/${workspaceId}`);
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  createWorkspaceFolder(request, Showloader = true) {
    const url = `api/office/workspace-folder`;
    return this.httpService.post(url, request, Showloader ? loaderTypes.default : loaderTypes.none).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  updateWorkspaceFolder(request) {
    const url = `api/office/workspace-folder`;
    return this.httpService.patch(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  deleteWorkspaceFolder(folderId) {
    const url = `api/office/workspace-folder/${folderId}`;
    return this.httpService.delete(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  getWorkspaceFiles(id) {
    const url = `api/office/workspace-forms/${id}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  getWorkspaceFilesInFolders(id, folderId) {
    const url = `api/office/workspace-forms/${id}/${folderId}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  getWorkspaceClient(id) {
    const url = `api/office/workspace-client/${id}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  getWorkspaceMember(id, folderId) {
    let url;

    folderId ? (url = `api/office/workspace-member/${id}/${folderId}`) : (url = `api/office/workspace-member/${id}`);
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  addWorkspaceClient(request) {
    const url = `api/office/workspace-client`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  addWorkspaceMember(request) {
    const url = `api/office/workspace-member`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  deleteWorkspaceClient(workspaceId, userId, model) {
    const url = `api/office/workspace-client/${workspaceId}/${userId}`;
    return this.httpService.delete(url, model).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  deleteWorkspaceMember(workspaceId, userId, folderId, Bodytype) {
    let url;

    folderId
      ? (url = `api/office/workspace-member/${workspaceId}/${userId}/${folderId}`)
      : (url = `api/office/workspace-member/${workspaceId}/${userId}`);

    return this.httpService.delete(url, Bodytype).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  deliverWorkspaceForms(request) {
    const url = `api/office/deliver-workspace-forms`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  moveFormsToWorkspace(request) {
    const url = `api/office/move-workspace-forms`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  moveFormsToWorkspaceFolders(request) {
    const url = `api/office/move-workspace-forms`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  deleteWorkspaceForms(request) {
    const url = `api/office/delete-workspace-forms`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  selectClient(client) {
    this.clientSelect.next(client);
  }

  triggerFolderCreation(isCreated) {
    this.folderCreated.next(isCreated);
  }

  navigateToClientGroup(client) {
    this.toClientGroup.next(client);
  }

  getClientNavigated() {
    return this.toClientGroup.asObservable();
  }

  getClient() {
    return this.clientSelect.asObservable();
  }

  getTriggerFolderCreation() {
    return this.folderCreated.asObservable();
  }

  requestFolderDownload(folder_id) {
    const url = `api/office/request-folder-download/${folder_id}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.files;
        }
      })
    );
  }

  getDeliverWorkspaceFormsProgress(deliveryTracker) {
    const url = `api/office/deliver-workspace-forms-progress`;
    return this.httpService.post(url, deliveryTracker).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  createIntegration(request) {
    const url = `api/office/integration-request`;
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  getFolderHierarchy(id) {
    const url = `api/office/workspace-folder-hierachy/${id}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  getFolderDetails(id) {
    const url = `api/office/workspace-folder-details/${id}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }
}
